module.exports = __webpack_public_path__ + "img/image62.83d42ca4.png";